import { create } from 'zustand';

type ErisAuthStore = {
  authenticated: boolean | null;
  serverCommunicationErrorExists: boolean;
  setAuthenticated: (authenticated: boolean | null) => void;
};

export const useErisAuthStore = create<ErisAuthStore>()((set) => ({
  authenticated: null,
  serverCommunicationErrorExists: false,
  setAuthenticated: (authenticated) => set({ authenticated }),
}));
